import axios from "axios";
import { getEnv } from "../config";
import APIError from "../models/ApiError";

const api = axios.create({
  baseURL: getEnv("REACT_APP_API_URL")
    ? getEnv("REACT_APP_API_URL")
    : "https://visualizador-back-dev.gcba.gob.ar/",
  withCredentials: true,
});

/* api.interceptors.request.use((config) => {
  const auth = JSON.parse(localStorage.getItem('auth') || '{}');
  if (auth.token) {
    config.headers.Authorization = `Bearer ${auth.token}`;
  }
  return config;
}); */

export const ApiNews = {
  async getArticles(config = {}) {
    try {
      const response = await api.get("/news/", config);
      return response.data;
    } catch (error) {
      if (
        error.code === "ECONNABORTED" &&
        error.message === "Request aborted"
      ) {
        throw error;
      }
      if (error.isAxiosError) {
        throw new APIError(
          error.response?.status || 500,
          error.response?.data?.message
        );
      }
      throw error;
    }
  },

  async getArticle(id) {
    try {
      const response = await api.get(`/news/${id}`);

      return response.data;
    } catch (error) {
      if (error.isAxiosError) {
        if (error.response?.status === 404) {
          throw new APIError(404, `Article with id ${id} not found`);
        }
        throw new APIError(
          error.response?.status || 500,
          error.response?.data?.message
        );
      }
      throw error;
    }
  },

  async getTags() {
    try {
      const response = await api.get("/news/tags");

      return response.data;
    } catch (error) {
      if (error.isAxiosError) {
        throw new APIError(
          error.response?.status || 500,
          error.response?.data?.message
        );
      }
      throw error;
    }
  },

  async createArticle(data) {
    try {
      const response = await api.post("/news/", data, {
        headers: {
          "X-XSRF-TOKEN": data.cookie,
        },
      });

      return response.data;
    } catch (error) {
      if (error.isAxiosError) {
        throw new APIError(
          error.response?.status || 500,
          error.response?.data?.message
        );
      }
      throw error;
    }
  },

  async updateArticle(id, data) {
    try {
      const response = await api.put(`/news/${id}`, data, {
        headers: {
          "X-XSRF-TOKEN": data.cookie,
        },
      });

      return response.data;
    } catch (error) {
      if (error.isAxiosError) {
        throw new APIError(
          error.response?.status || 500,
          error.response?.data?.message
        );
      }
      throw error;
    }
  },

  async deleteArticle(id) {
    try {
      const response = await api.put(`/news/${id}/deactivate`);
      return response.data;
    } catch (error) {
      if (error.isAxiosError) {
        if (error.response?.status === 404) {
          throw new APIError(404, `Article with id ${id} not found`);
        }
        throw new APIError(
          error.response?.status || 500,
          error.response?.data?.message
        );
      }
      throw error;
    }
  },
};

export default ApiNews;
